var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vipPriceItem flex flex-ver" },
    [
      _c("c-svg", {
        staticClass: "icon",
        attrs: { src: "coin-2159.svg", width: "16", height: "16" },
      }),
      _vm.price || _vm.price == 0
        ? _c("p", [_vm._v(_vm._s(_vm._f("conversion")(_vm.price || 0.0)))])
        : _vm._e(),
      _vm.stringValue || _vm.stringValue == ""
        ? _c("p", [_vm._v(_vm._s(_vm.stringValue))])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }